<template>
	<div class="person" style="width: 100%;min-height: 850px;background-color: white;">
		<div style="width: 100%;border-bottom: 1px solid #CACACA;height: 50px;margin-bottom: 0.9375rem;">
			<p style="line-height: 50px;margin-left: 10px;font-size: 15px;color: rgba(0, 0, 0, 0.85);">修改密码</p>
		</div>
		<a-form-model @submit.native.prevent  :rules="rules" ref="ruleForm" style="width: 75rem;margin: 0 auto;" layout="inline" :model="form">
			
			<div style="display: flex;flex-direction: column;align-items: center;">
				<a-col style="margin-top: 20px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						原密码
					</p>
					
					<a-form-model-item label="" prop="oriPassword">
						<a-input type="Password" style="width: 320px;height:2.6rem" v-model="form.oriPassword"
							placeholder="请输入原密码" />
					</a-form-model-item>
				</a-col>
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<a-col style="margin-top: 20px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						新密码
					</p>
					
					<a-form-model-item label="" prop="password">
						<a-input type="Password" style="width: 320px;height:2.6rem" v-model="form.password"
							placeholder="8-16位,包含数字大、小写字母" />
					</a-form-model-item>
					<div v-if="this.passCore>1" style="color: green;position: absolute;">当前密码强度为{{this.passCore==2?'一般':this.passCore==3?'正常':this.passCore==4?'良好':''}},可以使用</div>
				</a-col>
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<a-col style="margin-top: 20px;margin-bottom: 15px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						确认密码
					</p>
					<a-form-model-item label="" prop="password2">
						<a-input type="Password" style="width: 320px;height:2.6rem" v-model="form.password2"
							placeholder="8-16位,包含数字大、小写字母" />
					</a-form-model-item>
					<div v-if="this.passCore2>1" style="color: green;position: absolute;">当前密码强度为{{this.passCore2==2?'一般':this.passCore2==3?'正常':this.passCore2==4?'良好':''}},可以使用</div>
				</a-col>
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<a-col style="margin-top: 20px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;"></span>
						手机号码
					</p>
					<a-form-model-item label="" prop="phone">
						<a-input disabled type="text" style="width: 320px;height:2.6rem" v-model="form.phone"
							placeholder="请输入手机号后再发送短信" />
					</a-form-model-item>
				</a-col>
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<!-- <a-col style="margin-top: 20px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						验证码
					</p>
					<a-form-model-item label="" prop="password">
						<a-input type="Password" style="width: 320px;height:2.6rem" v-model="form.password"
							placeholder="请输入您收到的验证码" />
					</a-form-model-item>
				</a-col> -->
				
				<a-col  style="margin-top: 20px;margin-left: -12px;">
					<p style="color: #4B4B4B;font-size: 1rem;font-weight: 500;">
						<span style="color: #F64C4C;font-size: 13px;font-weight: 500;">*</span>
						验证码
					</p>
					
						<a-form-model-item label="" prop="smsCode">
							<div style="display: flex;position: relative;">
						<a-input style="width: 320px;height:2.6rem;" v-model="form.smsCode" 
							placeholder="请输入短信验证码" />
						<a-button :disabled="disabled" @click="sendcode"
							style="width: 4rem;height: 2rem;background-color: red;position: absolute; background: #1890FF;
						border-radius: 4px;font-size: 14px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;right: 2px;top: 5px;">
							{{btntxt}}
						</a-button>
						</div>
						</a-form-model-item>
					
					<a-modal class="modals" width="300px" style="" v-model="modalVisible2" @ok="handleOk2">
						<p style="color: #4B4B4B;font-size: 18px;">获取短信验证码</p>
						<div style="display: flex;align-items: center;height: auto">
							<a-input disabled class="boxYz" v-model="form.phone" type="UserName" placeholder="请输入手机号">
								<a-icon slot="prefix" type="phone" style="color:rgba(0,0,0,.25)" />
							</a-input>
						</div>
					</a-modal>
				</a-col>
				
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<a-col style="margin-top: 50px;" >
						<a-button @click="onSubmit" style="width: 320px;height:3.3rem;margin-left: -25px;" type="primary">
							确定
						</a-button>
					</a-col>
			</div>
			
			

		</a-form-model>
	</div>
</template>

<script>
	
	import {
		SendValidateCode,
		UpdateUserPwd,
		SelPersonalData
	} from '@/api/index.js'
	export default{
		name:'/core/updatePass',
		data(){
			var validatePassword = (rule, value, callback) => {
				console.log(rule)
			    const num = /^.*[0-9]+.*/
			      const low = /^.*[a-z]+.*/
			      const up = /^.*[A-Z]+.*/
			      const spe = /^.*[^a-zA-Z0-9]+.*/
			      const passLength = value.length >= 8 && value.length <= 16
				  let core = 0
				  //num.test(value) && low.test(value) && up.test(value)
			    if(passLength){
					if(num.test(value)){
						console.log("数字")
						core+=1
					}
					if(low.test(value)){
						console.log("小写字母")
						core+=1
					}
					if(up.test(value)){
						console.log("大写字母")
						core+=1
					}
					if(spe.test(value)){
						console.log("字符")
						core+=1
					}
					if(core<=1){
						setTimeout(()=>{
							this.passCore = core
						},200)
						
						callback('存在风险，至少使用大小写字母、数字、符号中2种')
					}
					else{
						setTimeout(()=>{
							this.passCore = core
						},200)
						callback()
					}
			     
			    }else{
					setTimeout(()=>{
						this.passCore = 0
					},200)
					 callback(new Error('密码长度错误，密码长度为8-16位'));
				}
			    
			  }
			  var validatePassword2 = (rule, value, callback) => {
			  	console.log(rule)
			      const num = /^.*[0-9]+.*/
			        const low = /^.*[a-z]+.*/
			        const up = /^.*[A-Z]+.*/
			        const spe = /^.*[^a-zA-Z0-9]+.*/
			        const passLength = value.length >= 8 && value.length <= 16
			  	  let core = 0
			  	  //num.test(value) && low.test(value) && up.test(value)
			      if(passLength){
			  		if(num.test(value)){
			  			console.log("数字")
			  			core+=1
			  		}
			  		if(low.test(value)){
			  			console.log("小写字母")
			  			core+=1
			  		}
			  		if(up.test(value)){
			  			console.log("大写字母")
			  			core+=1
			  		}
			  		if(spe.test(value)){
			  			console.log("字符")
			  			core+=1
			  		}
			  		if(core<=1){
			  			setTimeout(()=>{
			  				this.passCore2 = core
			  			},200)
			  			
			  			callback('存在风险，至少使用大小写字母、数字、符号中2种')
			  		}
			  		else{
			  			setTimeout(()=>{
			  				this.passCore2 = core
			  			},200)
			  			callback()
			  		}
			       
			      }else{
			  		setTimeout(()=>{
			  			this.passCore2 = 0
			  		},200)
			  		 callback(new Error('密码长度错误，密码长度为8-16位'));
			  	}
			      
			    }
			return{
				passCore:0,
				passCore2:0,
				form: {
					oriPassword: '',
					password: '',
					password2: '',
					phone:'',
					smsCode: '',
					
					modalVisible2:false,
				},
				rules: {
					password: [{ required: true, validator:validatePassword, trigger: 'change' }],
					password2: [{ required: true, validator:validatePassword2, trigger: 'change' }],
					oriPassword: [{
							required: true,
							message: '原密码不能为空',
							trigger: 'change'
						},
						
					],
					smsCode: [{
							required: true,
							message: '短信验证码不能为空',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 6,
							message: '短信验证码长度错误',
							trigger: 'blur'
						}
					],
					phone: [{
							required: true,
							message: '手机号不能为空',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度错误，请输入11位手机号',
							trigger: 'blur'
						}
					],
					
					
				},
				btntxt: '发送',
				disabled:false,
			}
		},
		created() {
			SelPersonalData().then((res)=>{
				this.form.phone = res.data.data.tol
			})
		},
		methods:{
			timer() {
				if (this.time > 0) {
					this.disabled = true;
					this.time--;
					this.btntxt = this.time + "秒再发";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "发送";
					
					this.disabled = false;
				}
			},
			sendcode() {
				SendValidateCode({cellPhone:this.form.phone,smsValidateType:2}).then((res)=>{
					if(res.data.state){
						this.modalVisible = false
						this.time = 60;
						this.timer()
					}else{
						this.$message.error(res.data.info);
					}
				})
				
			},
			onSubmit() {
							var that = this
							this.$refs.ruleForm.validate(valid => {
							        if (valid) {
										if(this.form.password!=this.form.password2){
											that.$message.error("密码与确认密码不一致")
											return
										}	 
										// if(this.form.masterNum!=''&&this.form.developNum!=''){
										// 	if(this.form.masterNum==this.form.developNum){
										// 		that.$message.error("主卡号与副卡号相同")
										// 		return
										// 	}
										// }
											 
										// console.log(this.form.username)
										let FORM = {
											cellPhone:this.form.phone?this.form.phone:'',
											pwd1:this.form.password?this.form.password:'',
											pwd2:this.form.password2?this.form.password2:'',
											smsCode:this.form.smsCode
										}
										console.log(FORM)
										UpdateUserPwd(FORM).then((res)=>{
											console.log(res)
											if(res.data.state){
												
												this.$message.success('修改密码成功')
												 location.reload()
												
												
											}
											else{
												this.$message.error(res.data.info)
											}
										})
							        
							        } else {
										
							          console.log('error submit!!');
												
							          return false;
							        }
							      });
								  }
			
		}
	}
</script>
<style>
	.person .ant-form-explain{
		position: absolute !important;
	}
	.person .ant-form-item-with-help{
		margin-bottom: 0 !important;
	}
</style>
